/* globals document */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import Submenu from './Submenu';
import Divider from "../Widgets/Divider";

import styles from './SubmenuWrapper.scss';

export default class SubmenuWrapper extends Component {
    static displayName = displayName('LeftHandNav/SubmenuWrapper');

    static propTypes = {
        links: PropTypes.array,
        buttonName: PropTypes.string.isRequired,
    };

    static defaultProps = {
        links: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            isSubmenuVisible: false,
        };

        this.justShowed = false;
    }

    componentDidMount() {
        document.addEventListener('click', this.hideSubMenu);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.hideSubMenu);
    }

    showSubMenu = () => {
        if (!this.state.isSubmenuVisible) {
            this.setState({ isSubmenuVisible: true });
            this.justShowed = true;
        }
    };

    hideSubMenu = () => {
    // ignore the first call to this method, since it's the document
    // event listener picking up the first click.
        if (this.state.isSubmenuVisible && !this.justShowed) {
            this.setState({ isSubmenuVisible: false });
        }

        this.justShowed = false;
    };

    render() {
        const buttonStyle = `new-button${this.state.isSubmenuVisible ? '-focused' : ''}`;

        return (
            <data>
                <div
                    role="presentation"
                    className={styles['submenu-wrapper']}
                    data-action="new"
                    data-section="left-hand-nav-submenu"
                    onClick={this.showSubMenu}
                >
                    {this.state.isSubmenuVisible && <Submenu links={this.props.links} />}
                    <span className={styles[buttonStyle]}>
                        {this.props.buttonName}
                    </span>
                </div>
                <Divider data-tag="divider" />
            </data>
        );
    }
}
